import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-3 rounded-md bg-greyLight p-4 text-grey" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "ml-3 min-w-0 flex-1" }
const _hoisted_4 = { class: "flex items-center space-x-2" }
const _hoisted_5 = { class: "truncate text-sm font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "shrink-0 rounded bg-primary px-2 py-0.5 text-[10px] font-semibold text-grey"
}
const _hoisted_7 = { class: "mt-1 text-xs text-grey text-opacity-50" }
const _hoisted_8 = { class: "mt-4 grid grid-cols-4 gap-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mt-1 text-[10px]" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex h-12 w-12 items-center justify-center rounded-lg bg-red/10" }, [
        _createElementVNode("i", { class: "fas fa-file-pdf text-2xl text-red" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.document.name), 1),
          (_ctx.document.isNew)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " новый "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.document.size), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "flex flex-col items-center justify-center rounded-lg bg-background py-2.5 text-blue transition",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open', _ctx.document)))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "fas fa-eye text-lg" }, null, -1),
        _createElementVNode("span", { class: "mt-1 text-[10px]" }, "Открыть", -1)
      ]))]),
      _createElementVNode("button", {
        type: "button",
        class: "flex flex-col items-center justify-center rounded-lg bg-background py-2.5 text-blue transition",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('download', _ctx.document)))
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("i", { class: "fas fa-download text-lg" }, null, -1),
        _createElementVNode("span", { class: "mt-1 text-[10px]" }, "Скачать", -1)
      ]))]),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["flex flex-col items-center justify-center rounded-lg py-2.5 transition", 
          _ctx.document.isSigned
            ? 'bg-green/10 text-green'
            : 'bg-blue text-white active:scale-95'
        ]),
        disabled: _ctx.document.isSigned,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sign', _ctx.document)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.document.isSigned ? 'fas fa-check text-lg' : 'fas fa-pen text-lg')
        }, null, 2),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.document.isSigned ? "Подписано" : "Подписать"), 1)
      ], 10, _hoisted_9),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["flex flex-col items-center justify-center rounded-lg py-2.5 transition", 
          _ctx.document.isSigned
            ? 'bg-green text-white active:scale-95'
            : 'bg-background text-grey text-opacity-30'
        ]),
        disabled: !_ctx.document.isSigned,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('send', _ctx.document)))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("i", { class: "fas fa-paper-plane text-lg" }, null, -1),
        _createElementVNode("span", { class: "mt-1 text-[10px]" }, "Отправить", -1)
      ]))], 10, _hoisted_11)
    ])
  ]))
}